import React, { useEffect, useState } from "react";
import { dateTimeToString, formatComma } from "../../utils/stringFormat";
import ReportLogWoodDetail from "../../components/reports/ReportLogWoodDetail";
import { useTranslation } from "react-i18next";
import useDropdownItem from "../../hooks/useDropdownItem";
import { URL_LOG_WOOD } from "../../constance/urls";


function ReportLogWoodCutWeightView() {
  const { t } = useTranslation();
  const cutWeightChoices = useDropdownItem({ url: URL_LOG_WOOD.CUT_WEIGHT });

  const defaultColumns = [
    {
      title: t("datas.index"),
      dataIndex: "index",
      width: 80,
    },
    {
      title: t("date_title"),
      dataIndex: "in_date_time",
      width: 140,
      render: (value) => <span>{dateTimeToString(value)}</span>,
    },
    {
      title: t("long_wood_lenght.license_plate"),
      dataIndex: "license_plate",
      width: 120,
    },
    {
      title: t("truck_companies.code"),
      dataIndex: "truck_company_code",
      width: 120,
    },
    {
      title: t("truck_companies.name"),
      dataIndex: "truck_company_name",
      width: 220,
    },
  ];

  const [columns, setColumns] = useState(defaultColumns);

  useEffect(() => {
    if (!cutWeightChoices.response.length) return;

    const dynamicColumns = cutWeightChoices.response
      .sort((a, b) => a.id - b.id)
      .map((cutWeight) => ({
        title: cutWeight.name,
        children: [
          {
            title: t("units.kilo_gram"),
            dataIndex: `report.${cutWeight.name}_weight`,
            render: (text, record) =>
              formatComma(record?.report?.[`${cutWeight.name}_weight`], 0),
          },
          {
            title: "%",
            dataIndex: `report.${cutWeight.name}_percent`,
            render: (text, record) => formatComma(record?.report?.[`${cutWeight.name}_percent`], 0),
          },
        ],
      }));

    const totalColumn = {
      title: t("datas.total"),
      children: [
        {
          title: t("units.kilo_gram"),
          dataIndex: "report.total_weight",
          render: (text, record) => formatComma(record?.report?.total_weight, 0),
        },
        {
          title: "%",
          dataIndex: "report.total_percent",
          render: (text, record) => formatComma(record?.report?.total_percent, 0),
        },
      ],
    };

    setColumns([...defaultColumns, ...dynamicColumns, totalColumn]);
  }, [cutWeightChoices.response, t]);

  return (
    <>
      <ReportLogWoodDetail
        title={t('menus.report_menus.log_wood_menus.cut_weight')}
        url={URL_LOG_WOOD.REPORT_CUT_WEIGHT}
        tableColumns={columns}
        exportUrl={URL_LOG_WOOD.REPORT_CUT_WEIGHT_EXPORT} />
    </>
  )
}

export default ReportLogWoodCutWeightView;